<template>
  <div class="home">
  
    <Reproductor msg="Los números" audio2="../mp3/PrimariaC/03PC.mp3" cover="../img/3.jpg" name="Primaria C - Lección #3"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
